import { SIZES } from './Progress.enum';

export function getProgress(value: number, maxValue: number) {
  const current = Number(((value / maxValue) * 100).toFixed(2));
  const remaining = Number((((maxValue - value) / maxValue) * 100).toFixed(2));

  return {
    current,
    isCompleted: current >= 100,
    remaining,
  };
}

export function getCircleProgress(size: keyof typeof SIZES, value: number, maxValue: number) {
  const { current: currentPercent } = getProgress(value, maxValue);
  const normalizedRadius = 60 - SIZES[size] * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const offset = circumference - (currentPercent / 100) * circumference;

  return {
    circumference,
    currentPercent,
    normalizedRadius,
    offset,
  };
}
